<div class="h-full flex flex-col gap-2 z-0 relative overflow-y-auto p-2 lg:pl-0">
<div class="max-w-6xl p-4 rounded-lg bg-white dark:bg-zinc-950 border" [ngClass]="{
            'shadow-lg border border-zinc-950/10 dark:border-white/10': source !== 'modal'
          }">
        <form [formGroup]="thresholdForm" (ngSubmit)="onSubmit()">
            <h1 *ngIf="source !== 'modal'" class="heading">
                {{thrsholdId ? 'Edit' : 'Add'}}
            </h1>
            <hr *ngIf="source !== 'modal'" class="my-4 mt-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
            <section class=" grid gap-4 md:grid-cols-2 lg:grid-cols-2 p-3 rounded-lg bg-white dark:bg-transparent">
                <div class="space-y-1">
                    <label class="subheading">
                        Miles <span class="text-red-600">*</span>
                    </label>
                    <div>
                        <div>
                            <input formControlName="miles" type="number" />
                        </div>
                        <div *ngIf="submitted && form.miles.errors">
                            <p *ngIf="form.miles.errors.required" class="pt-1 text-red-600 text-xs">
                                Miles are required
                            </p>
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Trips <span class="text-red-600">*</span>
                    </label>
                    <div>
                        <div>
                            <input formControlName="trips" type="number" />
                        </div>
                        <div *ngIf="submitted && form.trips.errors">
                            <p *ngIf="form.trips.errors.required" class="pt-1 text-red-600 text-xs">
                                Trips are required
                            </p>
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Amount <span class="text-red-600">*</span>
                    </label>
                    <div>
                        <div>
                            <input formControlName="amount" type="number" />
                        </div>
                        <div *ngIf="submitted && form.amount.errors">
                            <p *ngIf="form.amount.errors.required" class="pt-1 text-red-600 text-xs">
                                Amount is required
                            </p>
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">Space Type <span class="text-red-600">*</span></label>
                    <div>
                        <select name="user" id="user" formControlName="spaceType">
                            <option value="">Select Space Type</option>
                            <option *ngFor="let spaceType of spaceTypes" [value]="spaceType.id">{{ (spaceType.title | uppercase) }}</option>
                        </select>
                    </div>
                    <div *ngIf="submitted && form.spaceType.errors">
                        <p *ngIf="form.spaceType.errors.required" class="pt-1 text-red-600 text-xs">
                            Space Type is required
                        </p>
                    </div>
                </div>
            
                <!-- Status -->
                <div class="space-y-1">
                    <label class="subheading">
                        Status
                    </label>
                    <div>
                        <div>
                            <select formControlName="isActive">
                                <option [ngValue]='true'>Active</option>
                                <option [ngValue]='false'>Inactive</option>
                            </select>
                        </div>
                        <div *ngIf="submitted && form.isActive.errors">
                            <p *ngIf="form.isActive.errors.required" class="pt-1 text-red-600 text-xs">
                                Status is required
                            </p>
                        </div>
                    </div>
                </div>
            
            </section>
            <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
            <section class="flex justify-end gap-4">
                <button type="submit" class="btn btn-secondary">
                    {{thrsholdId ? 'Update' : 'Create'}}
                </button>
            </section>
        </form>
    </div>    
</div>